export const getFilters = state => {
  return state.pages.event.list.filters;
};

export const getNextUrl = state => {
  return state.pages.event.list.nextUrl;
};
